import { TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import RoundedTable from "@entrilia/shared/components/RoundedTable";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import TransactionEditContext from "./TransactionEditContext";
import TransactionRelatedEntityRow from "./TransactionRelatedEntityRow";

interface Props {
  loading?: boolean;
}

const TransactionRelatedEntitiesTable = ({ loading }: Props) => {
  const { editState } = useDefinedContext(TransactionEditContext);

  if (loading) {
    return <InlineLoader />;
  }

  if (editState.relatedEntities.length === 0) {
    return (
      <Typography color="textSecondary" sx={{ textAlign: "center", mt: 1, mb: 3 }}>
        No related entities
      </Typography>
    );
  }

  return (
    <RoundedTable noPaddingInBodyCells>
      <TableHead>
        <TableRow>
          <TableCell width="10%">Include</TableCell>
          <TableCell width="45%">Entity</TableCell>
          <TableCell width="45%">Funding Entity</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {editState.relatedEntities.map((relatedEntity) => (
          <TransactionRelatedEntityRow key={relatedEntity.changeSetId} relatedEntity={relatedEntity} />
        ))}
      </TableBody>
    </RoundedTable>
  );
};

export default TransactionRelatedEntitiesTable;
